import { PageHero, Reveal } from "../components/Reveal";
import { useSEO } from "../components/SEO";

const Section = ({ title, children }) => (
  <div className="py-8 border-t border-charcoal/10">
    <h2 className="text-xl font-semibold tracking-tight text-charcoal mb-3">{title}</h2>
    <div className="text-sm text-charcoal/65 leading-relaxed max-w-3xl space-y-3">
      {children}
    </div>
  </div>
);

const Layout = ({ tag, title, children, testid }) => (
  <main data-testid={testid}>
    <PageHero tag={tag} testid={`${testid}-hero`} lines={[title]} />
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6">
        <Reveal>{children}</Reveal>
      </div>
    </section>
  </main>
);

export const PrivacyPolicy = () => {
  useSEO("Privacy Policy | Nexus Catalyst Agency", "How Nexus Catalyst Agency collects, uses and protects your information.");
  return (
    <Layout tag="Legal" title="Privacy Policy." testid="privacy-page">
      <Section title="Overview">
        <p>
          Nexus Catalyst Agency ("we", "us") respects your privacy. This page
          explains, in plain terms, how information submitted through this
          website is handled. This is a template and should be reviewed and
          customised before commercial launch.
        </p>
      </Section>
      <Section title="Information We Collect">
        <p>
          When you submit the enquiry form, we collect the details you
          provide, such as your name, agency name, phone number, WhatsApp
          number, email, city, state, website and the marketing information
          you choose to share.
        </p>
      </Section>
      <Section title="How We Use It">
        <p>
          Your information is used only to respond to your enquiry, assess fit
          and communicate with you about our services. We do not sell your
          personal information.
        </p>
      </Section>
      <Section title="Contact">
        <p>
          Questions about this policy can be sent to
          nexuscatalystagency@gmail.com.
        </p>
      </Section>
    </Layout>
  );
};

export const Terms = () => {
  useSEO("Terms | Nexus Catalyst Agency", "Terms of use for the Nexus Catalyst Agency website.");
  return (
    <Layout tag="Legal" title="Terms of Service." testid="terms-page">
      <Section title="Overview">
        <p>
          These terms govern the use of this website. This is a template and
          should be reviewed and customised before commercial launch.
        </p>
      </Section>
      <Section title="No Guaranteed Outcomes">
        <p>
          Content on this website describes marketing services in general
          terms. Marketing performance varies based on market, offer, budget,
          seasonality, competition and each agency's sales process. Nothing on
          this website constitutes a guarantee of leads, bookings or revenue.
        </p>
      </Section>
      <Section title="Pricing">
        <p>
          Prices shown are starting points in Indian Rupees (₹). Final pricing
          depends on scope, campaign complexity, market coverage and
          advertising requirements. Advertising spend is separate from service
          fees.
        </p>
      </Section>
      <Section title="Intellectual Property">
        <p>
          All content on this website belongs to Nexus Catalyst Agency unless
          stated otherwise and may not be reproduced without permission.
        </p>
      </Section>
    </Layout>
  );
};

export const CookiePolicy = () => {
  useSEO("Cookie Policy | Nexus Catalyst Agency", "How the Nexus Catalyst Agency website uses cookies and analytics.");
  return (
    <Layout tag="Legal" title="Cookie Policy." testid="cookies-page">
      <Section title="Overview">
        <p>
          This website may use cookies and similar technologies to understand
          how visitors use the site and to measure marketing performance.
          This is a template and should be reviewed and customised before
          commercial launch.
        </p>
      </Section>
      <Section title="Analytics">
        <p>
          The site is prepared for tools such as Google Analytics, Google Tag
          Manager and Meta Pixel. When enabled, these tools may set cookies to
          measure visits, campaign performance and conversions.
        </p>
      </Section>
      <Section title="Your Choices">
        <p>
          You can control or delete cookies through your browser settings.
          Disabling cookies may affect how some features of the site behave.
        </p>
      </Section>
    </Layout>
  );
};
